import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { errorHelper } from '../../../utils/tools';
import { formValues } from './validationSchema';

import { Form, Row, Col, Button } from 'react-bootstrap';

import { addWarehouse, fetchWarehouses, checkWarehouseExists } from '../../../store/actions/warehouse';

const AddWarehouse = ({ isVisible, onClose }) => {
    const notifications = useSelector(state => state.notifications);
    const currentBranch = useSelector(state => state.branch.current);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isChecking, setIsChecking] = useState(false);
    
    const formik = useFormik({
        initialValues: formValues,
        validationSchema: Yup.object({
            warehouse: Yup.string()
                .required('Názov skladu je povinný')
                .min(3, 'Názov skladu musí mať minimálne 3 znaky')
                .max(16, 'Názov skladu môže mať maximálne 16 znakov')
                .test('checkDuplicateWarehouse', 'Sklad s týmto názvom už existuje', async (value) => {
                    if (!value) return true;
                    setIsChecking(true);
                    try {
                        const result = await dispatch(checkWarehouseExists({ branchId: currentBranch, warehouse: value })); 
                        const exists = result.payload;
                        return !exists; // Ak exists je true, vráti false, čo spôsobí chybu
                    } catch (error) {
                        console.error('Error checking warehouse:', error);
                        return false;
                    } finally {
                        setIsChecking(false);
                    }
                })
        }),
        onSubmit: (values) => {
            handleSubmit(values);
        },
        validateOnChange: true,
        validateOnBlur: true,
    });

    // Reset form on success notification
    useEffect(() => {
        if (notifications && notifications.global.success) {
            formik.resetForm();
        }
    }, [notifications, formik]);

    const handleSubmit = (values) => {
        if (currentBranch !== '')
            values.branchId = currentBranch;
        
         // Send data
         dispatch(addWarehouse(values))
         .then(() => {
             if (currentBranch !== '') {
                 dispatch(fetchWarehouses(currentBranch));
             }
            // Close modal
            onClose();
         })
         .catch(error => {
             console.error("Error adding warehouse:", error);
         });
    };

 

    return (
        <Form onSubmit={formik.handleSubmit}>
            <h2>Pridať sklad</h2>
            <hr />

            <Row>
                <Form.Group className="mb-3" controlId="formBasicWarehouse">
                    <Form.Label>Názov skladu</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Názov skladu:"
                        {...formik.getFieldProps('warehouse')}
                        isInvalid={formik.touched.warehouse && formik.errors.warehouse}
                    />
                    <Form.Control.Feedback type="invalid">
                         {errorHelper(formik, 'warehouse').helperText}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Row className="mt-3">
                <hr />
                <Col className="d-flex justify-content-end">
                    <Button
                        className='button-custom-large'
                        variant='primary'
                        type="submit"
                    >
                        Pridať sklad
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default AddWarehouse;